import { BaseRouteService } from 'core/services';

class ShipmentDocumentRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'shipment-document/';
	}

	upload(files) {
		return super.create(this.base + 'import-shipment-document-multipart', files);
	}

	uploadDocument = (fulfillmentOrderId, type) => {
		return this.uriTemplateService.parse(this.base + 'upload/{fulfillmentOrderId}/{type}').expand({ fulfillmentOrderId, type });
	};

	printDocument = (fulfillmentOrderId, type) => {
		return this.uriTemplateService.parse(this.base + 'print/{fulfillmentOrderId}/{type}').expand({ fulfillmentOrderId, type });
	};

	getForFulfillmentOrder = fulfillmentOrderId => {
		return this.uriTemplateService.parse(this.base + 'for-fulfillment-order/{fulfillmentOrderId}').expand({ fulfillmentOrderId });
	};
}

export default ShipmentDocumentRouteService;
